import { type Color } from '@mui/material'

// reason: these are the color tokens so they are hardcoded
/* eslint-disable @dhl/mui/no-hardcoded-colors */
export const postYellow = {
  100: '#FBF7F1',
  200: '#F6EEE3',
  300: '#F2E6D5',
  400: '#EAD6BA',
  500: '#E1C59E',
  600: '#D4AC74',
  700: '#CC9D5B',
  800: '#C58E42',
  900: '#AF7D36',
} satisfies Partial<Color>
